import { render, staticRenderFns } from "./ShopVisitCount.vue?vue&type=template&id=7ed08448&"
import script from "./ShopVisitCount.vue?vue&type=script&lang=js&"
export * from "./ShopVisitCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports